import { makeStyles } from "@material-ui/core";

export default makeStyles(
  (theme) => ({
    root: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      [theme.breakpoints.up("mobile")]: {},
      [theme.breakpoints.up("tablet")]: {},
    },
    title: {
      textTransform: "uppercase",
      fontSize: theme.typography.pxToRem(14),
      lineHeight: "normal",
      letterSpacing: 1,
      [theme.breakpoints.up("mobile")]: {
        fontSize: theme.typography.pxToRem(22),
      },
    },
    subtitle: {
      display: "none",
      [theme.breakpoints.up("mobile")]: {
        display: "block",
        textTransform: "uppercase",
        fontSize: theme.typography.pxToRem(9),
        lineHeight: theme.typography.pxToRem(9),
      },
    },
    logos: {
      display: "grid",
      gridGap: 4,
      gridTemplateColumns: "repeat(4, 1fr)",
      [theme.breakpoints.up("mobile")]: {
        gridGap: 5,
      },
    },
    logo: {
      width: 27,
      [theme.breakpoints.up("mobile")]: {
        width: 50,
      },
    },
  }),
  { name: "PaymentMethods" },
);
